import React from 'react';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel: React.FC<TabPanelProps> = (props) => {
  const { children, value, index, ...other } = props;
  
  // Sadece görünür olması gereken tab'ı DOM'da render et
  // Tab gizli olduğunda DOM'dan kaldırılmak yerine gizlenir, bu performansı artırır
  const isActive = value === index;
  
  return (
    <div
      role="tabpanel"
      hidden={!isActive}
      id={`terms-tabpanel-${index}`}
      aria-labelledby={`terms-tab-${index}`}
      aria-hidden={!isActive}
      {...other}
      className={`tab-panel ${isActive ? 'active' : ''}`}
    >
      {children}
    </div>
  );
};

export default TabPanel; 